import { featuresModel } from 'APP/model/model';
import Entities from 'STORE';

export async function getCalendarIntegrationEnabled(): Promise<void> {
  let isCalendarIntegrationEnabled;
  try {
    isCalendarIntegrationEnabled = await featuresModel.getCalendarIntegrationEnabled();
  } catch {
    isCalendarIntegrationEnabled = false;
  }
  Entities.featuresStore.setIsCalendarIntegrationEnabled(isCalendarIntegrationEnabled);
}
